import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  BrandCodeChanged,
  ClearBrandOptions,
  CouponSetChanged,
  GetCouponsSuccess,
  PanelStatusChanged,
} from '../actions/search-brand.actions';
import { SearchBrandState } from '../models/brand-search.model';

const initialState: SearchBrandState = {
  panelExpanded: true,
  couponSetValues: [],
  selectedCouponSetCode: '',
  brandCode: '',
};

export const BrandManagementReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(CouponSetChanged, (state, { selectedCouponSetCode }) => ({
    ...state,
    selectedCouponSetCode,
  })),
  on(BrandCodeChanged, (state, { brandCode }) => ({
    ...state,
    brandCode,
  })),
  on(GetCouponsSuccess, (state, { res }) => {
    const couponSetValues = res.map((e: any) => ({
      title: e.title,
      code: e.code,
    }));
    return {
      ...state,
      couponSetValues,
    };
  }),
  on(ClearBrandOptions, (state) => ({
    ...state,
    selectedCouponSetCode: '',
    brandCode: '',
  })),
  on(ActiveComponentChanged, () => initialState)
);
